module.exports = __webpack_public_path__ + "774c654f18c1ec77d63f515b95be5336.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plans/columbia_university.png
// module id = 2011
// module chunks = 0